import styled from "styled-components";
import React, { useEffect, useState } from "react";
import closeBtn from "../../images/close.svg";
import backBtn from "../../images/back.svg";
import emptyIconProfile from "../../images/emptyIconProfile.svg"
import { Avatar } from "./DialogsList";
import { DialogsList } from "./DialogsList";
import { ActiveDialog } from "./ActiveDialog";
import usePortalService from "../../services/PortalService";
import useRole from "../../hooks/useRole";
import { UserRole } from "../../Enums/UserRole";
import { Dialog, Message } from "../../types";

const ChatLayout = styled.div`
    position: fixed;
    height: 100vh;
    min-width: 60vw;
    max-width: 846px;
    border-radius: 8px 0px 8px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    background-color: rgb(248, 248, 248);
    z-index: 999;
    top: 0;
    right: 0;

    @media (max-width: 640px) {
        width: 100%;
        background-color: #fff;
        height: 100%;
        bottom: 0;
        top: auto;
        height: calc(100% - 93.67px);
        box-shadow: none;   
    }
`
export const ChatHeader = styled.div<{mobileVisible: boolean, dialogHeaderVisible?: boolean}>`
    display: flex;
    background-color: rgb(248, 248, 248);
    justify-content: space-between;
    border-bottom: 1px solid rgba(209, 214, 220, 1);
    padding: 24px 24px 16px 24px;

    @media (max-width: 640px) {
        display: ${props => props.mobileVisible ? 'flex' : 'none'};
        align-items: center;
        border-top: 1px solid rgba(209, 214, 220, 1);
        padding: 8px 20px;
        gap: ${props => props.dialogHeaderVisible ? '33px' : '0px'};
        justify-content: ${props => props.dialogHeaderVisible ? 'unset' : 'space-between'};
    }
` 
const DialogsListContainer = styled.div<{mobileVisible: boolean}>`
    overflow: hidden auto;
    width: 43%;
    min-width: 300px;

    @media only screen and (max-width: 640px) {
        width: 100%;
        display: ${props => props.mobileVisible ? 'block' : 'none'}
    }
`

type ChatModalProps = {
    isOpen: boolean,
    onClose: () => void,
    dialogs: Dialog[],
    messages: Message[],
    lastReadMessageId: number,
    activeDialogId: number,
    onOpenDialog: (dialogId: number, intercolutorId: number) => void,
    onSendMessage: (message: string) => void,
    onRead: (messageId: number, unreadMessagesCount: number) => void
}

export const ChatModal = ({ isOpen, onClose, dialogs, messages, lastReadMessageId, activeDialogId, 
    onOpenDialog, onSendMessage, onRead } : ChatModalProps) => {

    const {getAvatar, getCompanyImage} = usePortalService();
    const {role} = useRole();
    
    const [avatar, setAvatar] = useState(emptyIconProfile);
    const [dialogVisible, setDialogVisible] = useState(activeDialogId !== -1);

    const avatarId = dialogs.find(item => item.dialogId === activeDialogId)?.avatarId;
    const intercolutorName = dialogs.find(item => item.dialogId === activeDialogId)?.intercolutorName;

    useEffect(() => {
        setDialogVisible(activeDialogId !== -1)
    }, [activeDialogId])

    useEffect(() => {
        if (role === UserRole.Manager) {
            if (avatarId) {
                getAvatar(avatarId)  
                .then(result => {
                    setAvatar(result)
                })
            } else setAvatar(emptyIconProfile)
        }
        else {
            if (avatarId) {
                getCompanyImage(avatarId)  
                .then(result => {
                    setAvatar(result)
                })
            } else setAvatar(emptyIconProfile)
        }
    }, [avatarId]);
    
    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'unset'
    }, [isOpen])

    return (
        isOpen ?
            <ChatLayout>
                <ChatHeader mobileVisible={!dialogVisible}>
                    <h3>Сообщения</h3>
                    <img 
                        src={closeBtn} 
                        onClick={() => onClose()} 
                        width={20}
                        height={20}
                        style={{cursor: 'pointer'}}
                    ></img>
                </ChatHeader>
                {window.screen.width <= 640 &&
                    <ChatHeader mobileVisible={dialogVisible} dialogHeaderVisible>
                        <img 
                            src={backBtn} 
                            onClick={() => setDialogVisible(false)} 
                            width={20}
                            height={20}
                            style={{cursor: 'pointer'}}
                        ></img>
                        <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <Avatar src={avatar} />
                            <h3 style={{fontSize: '16px'}}>{intercolutorName}</h3>
                        </div>
                    </ChatHeader>
                }
                <div style={{display: 'flex', height: 'calc(100% - 65px)'}}>
                    <DialogsListContainer className="scrollbar-light" mobileVisible={!dialogVisible}>
                        {(dialogs) && dialogs.map((item) => 
                            <DialogsList 
                                key={item.dialogId} 
                                dateTime={item.dateTime} 
                                messageText={item.messageText}
                                interlocutorName={item.intercolutorName}
                                chatId={item.dialogId}
                                unreadCount={item.countOfUnreadMessage}
                                onClickDialog={onOpenDialog}
                                interlocutorId={item.intercolutorId}
                                avatarId={item.avatarId}
                            ></DialogsList>
                        )}
                    </DialogsListContainer>
                    <ActiveDialog 
                        messageList={messages}
                        lastReadMessageId={lastReadMessageId}
                        onSendMessage={onSendMessage}
                        activeDialogId={activeDialogId}
                        onRead={onRead}
                        dialogVisible={dialogVisible}
                    ></ActiveDialog>
                </div>
            </ChatLayout>
        : null
    )
}